import { css, jsx } from '@emotion/core';
import React from 'react';

import { bp, colors } from '@/styles';

import Components from './Components';

const styles = {
  row: css`
    display: flex;
    width: 100%;
    @media ${bp.md} {
      margin: 0 auto;
      max-width: 1000px;
      flex-direction: row;
    }
  `,
};

const FullWidthParagraph = ({ blockData, entities }) => {
  return (
    <div css={styles.row}>
      {blockData.Components &&
        Array.isArray(blockData.Components) &&
        blockData.Components.map(c => (
          <Components componentData={entities.Components[c]} key={c} />
        ))}
    </div>
  );
};

FullWidthParagraph.propTypes = {};

export default FullWidthParagraph;
